import { useInfiniteQuery } from "@tanstack/react-query";
import { adminService } from "@/services/adminService";

/**
 * Hook to fetch employee chat messages for admin review with infinite scroll
 * @param userId - User ID to filter messages (required)
 * @param limit - Items per page (default: 30)
 */
export const useAdminMessages = (userId: string | undefined, limit = 30) => {
  return useInfiniteQuery({
    queryKey: ["admin", "messages", userId],
    queryFn: async ({ pageParam = 1 }) => adminService.getMessages(pageParam, limit, userId!),
    enabled: !!userId,
    getNextPageParam: (lastPage, allPages) => {
      const loadedCount = allPages.reduce((sum, page) => sum + page.data.length, 0);
      return loadedCount < lastPage.total ? allPages.length + 1 : undefined;
    },
    initialPageParam: 1,
  });
};
